import { render, staticRenderFns } from "./articulo_card.vue?vue&type=template&id=038af3c9&scoped=true&"
import script from "./articulo_card.vue?vue&type=script&lang=js&"
export * from "./articulo_card.vue?vue&type=script&lang=js&"
import style0 from "./articulo_card.vue?vue&type=style&index=0&id=038af3c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038af3c9",
  null
  
)

export default component.exports